import * as service from './services'
import to from 'await-to-js'

export const state = {
  pedido: null,
  pedidoCache: null
}

export const getters = {
  pedido: state => state.pedido,
  pedidoCache: state => {
    if (state.pedido) {
      return state.pedido
    }
    let pedidoCache = window.localStorage.getItem('pedido')
    if (pedidoCache) {
      return JSON.parse(pedidoCache)
    }
  }
}

export const mutations = {
  setPedido (state, payload) {
    state.pedido = payload
  },

  setPedidoCache (state, payload) {
    state.pedidoCache = payload
  }
}

export const actions = {
  setPedido ({commit}, payload) {
    commit('setPedido', payload)
  },

  setPedidoCache ({commit}, payload) {
    commit('setPedidoCache', payload)
  },

  async savePedido ({getters, dispatch}, payload) {
    dispatch('setLoading', true)

    const [error, response = {data: null}] = await to(service.save(payload))
    dispatch('setLoading', false)

    if (error) {
      dispatch('showErrorMsg', error)
      return Promise.reject(error.response.data)
    }

    return response.data
  },

  async getPedido ({dispatch}, id) {
    dispatch('setLoading', true)

    const [error, response = {data: null}] = await to(service.get(id))
    dispatch('setLoading', false)

    if (error) {
      dispatch('showErrorMsg', error)
      return Promise.reject(error.response.data)
    }

    return response.data
  },

  storePedido ({dispatch}, pedido) {
    window.localStorage.setItem('pedido', JSON.stringify(pedido))
    dispatch('setPedidoCache', pedido)
    return pedido
  },

  savePedidoFromCache ({getters, dispatch}) {
    let pedidoCache = getters.pedidoCache
    pedidoCache.cliente = getters.user.id
    return dispatch('savePedido', pedidoCache)
  },

  async updatePedido ({getters, dispatch}, pedido) {
    dispatch('setLoading', true)

    const [error, response = {data: null}] = await to(service.update(pedido._id, pedido))
    dispatch('setLoading', false)

    if (error) {
      dispatch('showErrorMsg', error)
      return Promise.reject(error.response.data)
    }

    return response.data
  },

  async aplicarCupom (context, payload) {
    context.dispatch('setLoading', true)

    const [error, response = {data: null}] = await to(service.aplicarCupom(payload))
    context.dispatch('setLoading', false)

    if (error) {
      context.dispatch('showErrorMsg', error)
      return Promise.reject(error.response.data)
    }

    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/pedido/index.js